import {Component, Input, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {Location} from '@angular/common';
import {DispatcherService} from 'front-base-angular-core/angular/projects/front-base-angular-core/src/public-api';

@Component({
  selector: 'si-history-back-icon',
  templateUrl: './history-back-icon.component.html',
  styleUrls: ['./history-back-icon.component.scss']
})
export class HistoryBackIconComponent implements OnInit {
  @Input() styleClass: string;
  subscriptions: Subscription[] = [];
  historyBackShowIcon = false;
  historyBackLocationBack = true;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private dispatcher: DispatcherService
  ) {
  }

  ngOnInit(): void {
    this.onNavigationEnd();
    this.subscriptions.push(
      this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe(() => this.onNavigationEnd())
    );
  }

  onNavigationEnd(): void {
    this.getRouteData();
  }

  getRouteData(): void {
    let routeSnapshot = this.activatedRoute.snapshot;
    while (routeSnapshot.firstChild) {
      routeSnapshot = routeSnapshot.firstChild;
    }

    const routeData = routeSnapshot.data;
    this.historyBackShowIcon = routeData.historyBackShowIcon === true;
    this.historyBackLocationBack = routeData.historyBackLocationBack !== false;
  }

  onClickIcon(event: Event): void {
    event.stopPropagation();
    if (this.historyBackLocationBack) {
      this.location.back();
    }

    this.dispatcher.exec('pasi-history-back-icon-clicked', true);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
